import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MARKETING_CTAS } from '@/lib/marketingCtas';

/** Close (spec 010 §3.6): the account-free start, and a way back for returning students. */
export function HomeClose() {
  return (
    <section aria-labelledby="close-title" className="px-4 pb-16 sm:px-6 lg:pb-24">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 rounded-3xl bg-primary px-6 py-10 text-primary-foreground sm:px-10 md:flex-row md:items-center md:justify-between lg:py-14">
        <h2 id="close-title" className="text-3xl font-bold tracking-tight sm:text-4xl">
          Start where you are.
        </h2>
        <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:gap-5">
          <Button asChild size="lg" className="h-12 bg-background text-base text-foreground hover:bg-background/90">
            <Link to={MARKETING_CTAS.closeCourse.href}>{MARKETING_CTAS.closeCourse.label}</Link>
          </Button>
          <Link
            to={MARKETING_CTAS.login.href}
            className="self-center rounded text-sm font-medium underline underline-offset-4 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-foreground"
          >
            {MARKETING_CTAS.login.label}
          </Link>
        </div>
      </div>
    </section>
  );
}
